import React, { FC } from "react";
import { Text } from "@mantine/core";

import {
  getItemInlayCoreHasClavetteLabel,
  getItemInlayCoreMaterialLabel,
  getItemInlayCoreScanPostTranslated,
  getItemShadeLabel,
} from "../../utils/item.utils";
import { AnatomyItem } from "../../types/interfaces";
import { ItemType } from "../../types/enums";

type ItemsDescriptionProps = {
  item: AnatomyItem;
  shouldTranslate: boolean;
};

export const ItemsDescriptionAnatomyItem: FC<ItemsDescriptionProps> = ({
  item,
  shouldTranslate,
}) => {
  if (!item) return null;

  return (
    <>
      {item.itemType !== ItemType.INLAY_CORE && (
        <>
          {item.itemShade && (
            <Text size="sm">
              {shouldTranslate
                ? `- Item shade : ${getItemShadeLabel(item)}`
                : `- Teinte : ${getItemShadeLabel(item)}`}
            </Text>
          )}
          {item.multiShadeInfo && (
            <>
              {item.multiShadeInfo.map(multiShadeInfo => (
                <Text size="sm" key={multiShadeInfo.teethShadeSide}>
                  {`- ${multiShadeInfo.teethShadeSide} : ${multiShadeInfo.itemShade.label}`}
                </Text>
              ))}
            </>
          )}
        </>
      )}
      {(item.itemType === ItemType.INLAY_CORE ||
        item.itemType === ItemType.POST_AND_CORE_RETAINED_CROWN ||
        item.itemType === ItemType.RICHMOND_CROWN) && (
        <>
          {getItemInlayCoreMaterialLabel(item, shouldTranslate) && (
            <Text size="sm">{`- ${getItemInlayCoreMaterialLabel(item, shouldTranslate)}`}</Text>
          )}
          {getItemInlayCoreHasClavetteLabel(item, shouldTranslate) && (
            <Text size="sm">{`- ${getItemInlayCoreHasClavetteLabel(item, shouldTranslate)}`}</Text>
          )}
          {getItemInlayCoreScanPostTranslated(item, shouldTranslate) && (
            <Text size="sm">{`- ${getItemInlayCoreScanPostTranslated(item, shouldTranslate)}`}</Text>
          )}
        </>
      )}
    </>
  );
};
